function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DatalayerScene } from '@finect/front-gtm';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { ManagementCompaniesList, ManagementCompaniesFilters } from '@finect/tabular-components/Modules';
import { Head } from '@finect/tabular-components/Head';
import { getProductTypeLabel, getProductTypeBySlug, getFundsManagementCompaniesPath } from '@finect/front-resources/Products';
import { getManagementCompanies, getCategories } from '../commons/store/fund/actions';
import { FamilyInsideNavigation } from '../commons/IIC/components';
import { parseOrderParam } from '../commons/IIC/utils/fundsFilters';
import { getManagementCompaniesCategories, reduceManagementCompanies, orderParams } from './utils';
const mapStateToProps = state => ({
  managementCompanies: state.fund.managementCompanies
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getManagementCompanies,
    getCategories
  }, dispatch)
});
class ManagementCompanies extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      category: null,
      managementCompanies: this.props.managementCompanies,
      filter: {
        order: 'abc',
        search: ''
      },
      view: 'grid'
    });
    _defineProperty(this, "handleViewChange", view => {
      this.setState({
        view
      });
    });
    _defineProperty(this, "handleCategoryReturn", value => {
      const checkedIDs = value.filter(item => item.checked).map(item => item.id);
      this.setState({
        category: checkedIDs.length ? checkedIDs[0] : null,
        managementCompanies: reduceManagementCompanies(this.props.managementCompanies, checkedIDs)
      });
    });
    _defineProperty(this, "handleSearch", value => {
      const newFilter = _objectSpread({}, this.state.filter);
      newFilter.search = value;
      this.setState({
        filter: newFilter
      });
    });
    _defineProperty(this, "handleOrderChange", order => {
      const newFilter = _objectSpread({}, this.state.filter);
      newFilter.order = parseOrderParam(order[0].id).slug;
      this.setState({
        filter: newFilter
      });
    });
    _defineProperty(this, "handleRestore", () => {
      this.setState({
        filter: {
          order: 'abc',
          search: ''
        }
      });
    });
  }
  static loadInitialData(store, cookie, match) {
    const productType = getProductTypeBySlug(match.params.typeSlug);
    return store.dispatch(getManagementCompanies(productType));
  }
  componentDidMount() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    if (!this.props.managementCompanies.length) {
      this.props.actions.getManagementCompanies(productType);
    }
  }
  render() {
    const {
      theme
    } = this.props;
    const {
      typeSlug
    } = this.props.match.params;
    const productType = getProductTypeBySlug(typeSlug);
    const categories = getManagementCompaniesCategories(this.props.managementCompanies);
    const selectedCategoryId = this.state.category ? this.state.category.toString() : null;
    const category = categories.find(element => element.id.toString() === selectedCategoryId);
    const order = orderParams.find(param => param.slug.includes(this.state.filter.order));
    const managementCompaniesFiltered = this.state.filter.search.length ? this.props.managementCompanies.filter(company => company.name.toLowerCase().includes(this.state.filter.search.toLowerCase())) : this.props.managementCompanies;
    const managementCompanies = order ? managementCompaniesFiltered.sort(order.sort) : managementCompaniesFiltered;
    return React.createElement(Fragment, null, React.createElement(Head, {
      title: `Gestoras de ${getProductTypeLabel(productType, 'plural', 'lowercase')}`,
      description: `Gestoras de ${getProductTypeLabel(productType, 'plural', 'lowercase')}`,
      canonical: getFundsManagementCompaniesPath(theme, productType)
    }), React.createElement(DatalayerScene, {
      pageType: "home",
      pageId: "managementCompanies"
    }), React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      productType: productType,
      current: "categories"
    }), React.createElement(ContainerInner, {
      withInsideNavigation: true
    }, React.createElement(MainContent, {
      fullWidth: true
    }, React.createElement(ManagementCompaniesFilters, {
      category: category,
      categories: categories,
      search: this.state.filter.search,
      onCategoryChange: this.handleCategoryReturn,
      onSearchChange: this.handleSearch,
      onOrderChange: this.handleOrderChange,
      onRestore: this.handleRestore,
      orders: orderParams,
      order: order,
      view: this.state.view,
      onViewChange: this.handleViewChange,
      qty: managementCompanies.length,
      totalItems: this.props.managementCompanies.length
    }), React.createElement(ManagementCompaniesList, {
      view: this.state.view,
      productType: productType,
      managementCompanies: managementCompanies
    })))));
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(ManagementCompanies));